<template>
  <div id="mobile-index">
    <mheader></mheader>
    <img src="../../assets/mobile/1.png" width="100%"/>
    <div class="h-text">
      <p>数字创造价值</p>
      <p>科技引领未来</p>
      <p style="font-size: 0.81rem;line-height: 1.13rem;font-weight: lighter;margin-top: 1.44rem;">Digital creates value</p>
      <p style="font-size: 0.81rem;line-height: 1.13rem;font-weight: lighter;">technology leads the future</p>
    </div>
    <div style="position: absolute;left: 50%;transform: translateX(-50%);width: 16rem;height: 9rem;top: 20rem">
      <video src="../../assets/1.mp4" controls="" style="width: 100%" webkit-playsinline></video>
<!--      <a href="javascript:;" class="close"><img src="../../assets/close.png"></a>-->
    </div>
    <div class="h-m-1">
      <div>
        <h2>{{companyInfo.fprofileName}}</h2>
        <p></p>
        <span>{{companyInfo.fprofileSummary}}</span>
      </div>
    </div>
    <div class="h-m-2">
      <div v-for="(item,index) in solutions">
        <div class="c-m-1" v-if="index === 0">
          <img src="../../assets/mobile/2.png" width="100%" />
          <p>"数字化"改革业务</p>
          <span>以数字化改革引领生活高质量发展</span>
        </div>
        <div class="c-m-2" v-else-if="index === 6">
          <img src="../../assets/mobile/3.png" width="100%" />
          <p>智慧交通物流业务</p>
          <span>为交通物流参与者提供多样性服务</span>
        </div>
        <div class="c-m-3" v-else>
          <img :src="baseUrl + item.fsolutionUrl"/>
          <p>{{item.fsolutionName}}</p>
        </div>
      </div>
    </div>
    <div  class="h-m-3">
      <h2>合作客户</h2>
        <div>
          <img v-for="(item ,index ) in Cooperation" :src="baseUrl + item.fcooperation" :key="index" alt=""/>
        </div>
    </div>
  </div>

</template>

<script>
  import mheader from './common/header'
  import axios from "../../../static/js/commonAxios";
  export default {
    data(){
      return{
        baseUrl: '',
        companyInfo: '',
        solutions: [],
        Cooperation: []
      }
    },
    components: {
      mheader
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getCompanyDate()
      this.getSolutionDate()
      this.getCompanyCooperation()
    },
    methods: {
      getCompanyDate(){
        axios.get('/api/profile').then((res) => {
          if(res.data.success){
            this.companyInfo = res.data.items?res.data.items[0]:''
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getSolutionDate(){
        axios.get('/api/solution').then((res) => {
          if(res.data.success){
            this.solutions = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getCompanyCooperation(){
        axios.get('/api/cooperation').then((res) => {
          if(res.data.success){
            this.Cooperation = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
    },
  }
</script>

<style>
  #mobile-index {
    position: relative;
    background-color: #fff;
  }
  #mobile-index .h-text {
    width: 12rem;
    position: absolute;
    top: 10.2rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }
#mobile-index .h-text p{
  font-size: 1.88rem;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 2.56rem;
}
  #mobile-index .h-m-1 {
    margin-top: 4rem;
    padding: 3.53rem 1.9rem 0rem 1.9rem;
    background-color: #fff;
  }
  #mobile-index .h-m-1 div h2 {
    height: 1.78rem;
    font-size: 1.88rem;
    font-weight: 500;
    color: #3E4266;
    line-height: 1.41rem;
  }
  #mobile-index .h-m-1 div p {
    width: 1.25rem;
    height: 0.13rem;
    background: #89B929;
    margin: 1rem 0 2.5rem 0;
  }
  #mobile-index .h-m-1 div span {
    font-size: 0.94rem;
    font-weight: 300;
    color: #666666;
    line-height: 1.5rem;
  }
  #mobile-index .h-m-2 {
    margin-top: 4rem;
    background-color: #2E86EB;
  }
  #mobile-index .c-m-1, #mobile-index .c-m-2{
    position: relative;
    width: 100%;
    height: 8.88rem;
  }
  #mobile-index .c-m-1 p,#mobile-index .c-m-2 p {
    position: absolute;
    left: 1.9rem;
    top: 2.7rem;
    font-size: 1.31rem;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 2.25rem;
  }
  #mobile-index .c-m-1 span,#mobile-index .c-m-2 span {
    position: absolute;
    left: 1.9rem;
    top: 5.1rem;
    font-size: 0.88rem;
    font-weight: 400;
    color: #B4D7FF;
    line-height: 0.94rem;
  }
  #mobile-index .c-m-3{
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: 0rem 1.9rem 1.2rem 1.9rem;
    margin-bottom: 1.25rem;
  }
  #mobile-index .c-m-3 img{
    width: calc(100vw - 3.8rem);
    vertical-align: middle;
  }
  #mobile-index .c-m-3 p{
    box-sizing: border-box;
    background-color: #fff;
    font-size: 0.94rem;
    font-weight: 400;
    color: #333333;
    line-height: 1.51rem;
    padding: 0.77rem 0 0.77rem 1.06rem;
  }
  #mobile-index .h-m-3 {
    margin-top: 4rem;
    background-color: #fff;
    padding: 0rem 1.9rem 0rem 1.9rem;
    text-align: center;
  }
  #mobile-index .h-m-3 h2 {
    font-size: 1.31rem;
    font-weight: 500;
    color: #000000;
    margin-top: 1rem;
    margin-bottom: 3.1rem;
  }
  #mobile-index .h-m-3 div {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0rem 1.9rem 0rem 1.9rem;
  }
  #mobile-index .h-m-3 div img {
    display: inline-block;
    width: 7rem;
    margin-bottom: 0.3rem;
    /*height: 2.5rem;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/mobie.vue